import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles({
  updateBtn: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.warning700,
    display: "inline-flex",
    alignSelf: "center",
    alignItems: "center",
    borderRadius: "8px",
    cursor: "pointer",
    "& path": {
      stroke: colors.warning700
    },
    "& svg": {
      stroke: colors.warning700,
      width: "20px !important",
      height: "20px !important",
      cursor: "pointer"
    },
  },
  mainBannerWrapper: {
    backgroundColor: colors.warning25,
    paddingTop: "12px",
    paddingBottom: "12px",
    border: `1px solid ${colors.warning200}`,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      paddingLeft: "30px"
    },
  },
  textWrapper: {
    marginTop: "-20px",
    paddingLeft: "12px"
  },
  firstPar: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.warning700,
    marginBottom: "4px"
  },
  bannersContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1050,
    "& .alert": {
      position: "relative !important",
    },
  },
  bannersContainerWithManagedBar: {
    top: "52px",
  },
  bannerPresentMainStyle: {
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: 0
    }
  },
  downMain: {
    [`@media (min-width: ${breakpoints.md}px)`]: {
      marginTop: "72px"
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      marginTop: 0
    }
  },
  asAlertStyle: {
    "& .alert": {
      marginBottom: 0,
    },
    "& .alert-danger": {
      backgroundColor: colors.warning100,
      border: "none",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "20px",
      color: colors.warning700
    },
    "& div:nth-of-type(2)": {
      display: "none"
    },
  },
  amAlertStyle: {
    "& .alert-danger": {
      backgroundColor: colors.primary25Blue,
      border: "1px solid" + colors.primary300Blue,
       "& p": {
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "24px",
        color: colors.primary700AM,
        "& span": {
          fontWeight: "600"
        }
      },
      "& svg": {
        marginRight: "8px",
        borderRadius: "12px",
        padding: "2px",
        backgroundColor: colors.primary200Blue
      },
    },
  },
  tripCreditAlertBanner: {
    "& .alert-danger": {
      backgroundColor: colors.aquaBlue2,
      border: "none",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "20px",
      color: colors.blueLight700
    },
  },
  linkLearnMore: {
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.blueLight700,
    marginLeft: "6px" 
  },
  manageCompanyBannerPresent: {
    "& div:first-of-type": {
      zIndex: 2
    },
  },
  secondPar: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.warning700,
    marginBottom: "12px"
  },
  alertIcon: {
    "& svg": {
      width: "20px",
      height: "20px",
      marginLeft: "-20px"
    },
  },
  alertMsg: {
    margin: "10px",
    textAlign: "center",
    display: "grid"
  },
  alertMsgAM: {
    textAlign: "center",
    margin: 0,
    padding: "12px",
  },
  tripCreditMessageContainer: {
    margin: "10px 28px",
    textAlign: "center",
    display: "block",
    "& svg": {
      marginRight: "8px",
      verticalAlign: "middle"
    },
  },
  alertHeadline: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "6px",
  },

  alertBody: {
    fontSize: "14px",
    marginBottom: "8px",
  },

  alertLink: {
    fontSize: "14px",
    textDecoration: "none",
    fontWeight: 500,
    marginLeft: "5px"
  },
  insideAlertStyle: {
    margin: "0px",
    padding: "2px 2px !important",
    backgroundColor: colors.lightOrange,
    border: "none",
    "& .btn-close": {
      padding: "10px 10px !important",
      backgroundSize: "10px"
    },
  },
  choiceBanner: {
    margin: 0,
    backgroundColor: colors.gray25,
    border: `1px solid ${colors.gray600}`,
    boxShadow: "0 12px 16px -4px rgba(10, 13, 18, 0.08), 0 4px 6px -2px rgba(10, 13, 18, 0.03), 0 2px 2px -1px rgba(10, 13, 18, 0.04)"
  },
  choiceBannerTitle: {
    color: colors.gray700
  },
  choiceBannerDescription: {
    color: colors.choiceGray600
  },
  choiceCloseIconBanner: {
    marginTop: "auto",
    marginBottom: "auto",
    marginLeft: 0,
    "& path": {
      stroke: colors.choiceIconGray,
    },
  },
  noNavPageWrapper: {
    paddingLeft: "56px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      paddingLeft: "16px",
    },
  }
});

export default styles;